// extracted by mini-css-extract-plugin
export default {"advertDetailServiceList":"c-n_fP","advertDetailServiceList__header":"c-n_fQ","advertDetailServiceList__list":"c-n_fR"};